import type { ArrowData, Direction, Level } from './types';

export const FIRST_CUSTOM_LEVEL = 4;
export function assertCustomLevel(number: number): void {
  if (!Number.isInteger(number) || number < FIRST_CUSTOM_LEVEL || number > 100) {
    throw new Error('Levels 1–3 are reserved for FTUE. Choose a level from 4–100.');
  }
}

const arrow = (id: string, direction: Direction, ...points: [number, number][]): ArrowData => ({
  id, cells: points.map(([x, y]) => ({ x, y })), direction
});

/** Deliberately spaced, authored puzzles teach one idea at a time. Arrow order
 * is a valid solution, while several clear exits let players choose their move. */
export function openingLevel(number: number, seed: number, version: number): Level | null {
  let arrows: ArrowData[], width: number, height: number, introTip: string;
  switch (number) {
    case 1:
      width = 6; height = 7;
      introTip = 'Follow the tip. Every arrow here has a clear exit.';
      arrows = [
        arrow('a1', 'UP', [1, 2], [1, 1]),
        arrow('a2', 'RIGHT', [3, 1], [4, 1]),
        arrow('a3', 'LEFT', [2, 5], [1, 5]),
        arrow('a4', 'DOWN', [4, 4], [4, 5])
      ];
      break;
    case 2:
      width = 7; height = 8;
      introTip = 'An arrow in the way? Clear its blocker first.';
      arrows = [
        arrow('a1', 'UP', [5, 3], [5, 2]),
        arrow('a2', 'LEFT', [2, 1], [1, 1]),
        arrow('a3', 'DOWN', [1, 5], [1, 6]),
        arrow('a4', 'RIGHT', [2, 3], [3, 3]),
        arrow('a5', 'RIGHT', [3, 6], [4, 6], [5, 6]),
        arrow('a6', 'DOWN', [3, 4], [3, 5])
      ];
      break;
    case 3:
      width = 8; height = 10;
      introTip = 'Bends follow the tip too. Look for a clear path to the edge.';
      arrows = [
        arrow('a1', 'UP', [1, 2], [1, 1]),
        arrow('a2', 'RIGHT', [4, 1], [5, 1], [6, 1]),
        arrow('a3', 'DOWN', [6, 5], [6, 6], [6, 7]),
        arrow('a4', 'LEFT', [3, 4], [3, 3], [2, 3], [1, 3]),
        arrow('a5', 'UP', [4, 4], [5, 4], [5, 3]),
        arrow('a6', 'RIGHT', [2, 5], [3, 5], [4, 5]),
        arrow('a7', 'UP', [2, 7], [2, 6]),
        arrow('a8', 'DOWN', [5, 7], [4, 7], [4, 8])
      ];
      break;
    default: return null;
  }
  return {
    id: `level-${number}`, number, seed, generatorVersion: version,
    shape: 'rectangle', width, height, arrows, active: arrows.flatMap(arrow => arrow.cells),
    difficulty: 1, timeLimit: 20 + number * 10, introTip
  };
}
